
import { RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { RootState } from '@share/utils';
import { ICar } from '@share/common-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps extends RouteComponentProps {
  car: ICar;
}

export function CarsCardRefundability(props: IProps) {

  const { car } = props;
  const { refundable } = car;

  const { account, userWallet } = useSelector((state: RootState) => state.loginStore);
  const { selectedCarsReviewClientCash, bookingComplete, booking } = useSelector((state: RootState) => state.carsReviewBookStore);

  const isLogged = !!userWallet;

  const usedClientCash = (bookingComplete && booking && booking?.clientCashConsumed) ? booking?.clientCashConsumed : 0;

  const hasClientCash = account?.hasClientCash;
  const walletIsExternal = account?.walletIsExternal;

  const refundabilityFinal = (!walletIsExternal && hasClientCash && isLogged && (selectedCarsReviewClientCash > 0 || usedClientCash > 0)) ? false : refundable;

  return (
    <div className="hotel-card-wrapper__refundable cars-content" style={{ maxWidth: '160px' }}>
      { refundabilityFinal && (
        <div className="hotel-card-wrapper__refundable-ref">
          <FontAwesomeIcon icon={faCheck} /><FormattedMessage id="refundable" />
        </div>)}
      {!refundabilityFinal && (
        <div className="hotel-card-wrapper__refundable-nonref">
          <FontAwesomeIcon icon={faTimes} /><FormattedMessage id="non.refundable" />
        </div>)}
    </div>
  );
}
